import { useMemo } from 'react';
import { withAsyncBoundary } from '@toss/async-boundary';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'next-i18next';
import { PersonStackFillIcon } from '@zep/icons';
import { SubscribePlan } from '@zep/types';
import { Stack } from '@zep/ui';
import { SUBSCRIPTION_FEATURES, SUBSCRIPTION_FEATURES_JA } from '../../SubscriptionConst';
import S from './PlanApplyFeature.module.scss';
type PlanApplyFeatureProps = {
  title: string;
  plan: SubscribePlan;
  isDowngrade?: boolean;
  isJaPlan?: boolean;
};
export const PlanApplyFeature = ({
  title,
  plan,
  isDowngrade = false,
  isJaPlan = false
}: PlanApplyFeatureProps) => {
  const {
    t
  } = useTranslation(['subscription']);
  return <Stack className={S.feature_container} gap={10} data-sentry-element="Stack" data-sentry-component="PlanApplyFeature" data-sentry-source-file="PlanApplyFeature.tsx">
      <div className={S.section_title}>
        {isDowngrade ? t('subscription:checkout.complete.downgradeApplyFeatures') : t('subscription:payment.applyFeature.title')}
      </div>
      <Stack gap={8} data-sentry-element="Stack" data-sentry-source-file="PlanApplyFeature.tsx">
        <Stack gap={6} direction={'row'} className={S.section_sub_title} data-sentry-element="Stack" data-sentry-source-file="PlanApplyFeature.tsx">
          <PersonStackFillIcon width={16} height={16} data-sentry-element="PersonStackFillIcon" data-sentry-source-file="PlanApplyFeature.tsx" />
          {title}
        </Stack>
        <PlanBenefitsDescription plan={plan} isJaPlan={isJaPlan} data-sentry-element="PlanBenefitsDescription" data-sentry-source-file="PlanApplyFeature.tsx" />
      </Stack>
    </Stack>;
};
const PlanBenefitsDescriptionInner = ({
  plan,
  isJaPlan = false
}: {
  plan: string;
  isJaPlan: boolean;
}) => {
  const {
    t
  } = useTranslation(['subscription']);
  const features = useMemo(() => {
    const subscriptionFeatures = isJaPlan ? SUBSCRIPTION_FEATURES_JA : SUBSCRIPTION_FEATURES;
    return subscriptionFeatures[plan as SubscribePlan];
  }, [plan, isJaPlan]);
  return <Stack gap={8} data-sentry-element="Stack" data-sentry-component="PlanBenefitsDescriptionInner" data-sentry-source-file="PlanApplyFeature.tsx">
      {features?.map(feature => <Feature key={feature.key} icon={feature.icon({
      width: 16,
      height: 16
    })} description={t(feature.key as ParseKeys<['subscription']>)} />)}
    </Stack>;
};
const Feature = ({
  icon,
  description
}: {
  icon: React.ReactNode;
  description: string;
}) => <Stack className={S.section_sub_description} direction={'row'} gap={6} data-sentry-element="Stack" data-sentry-component="Feature" data-sentry-source-file="PlanApplyFeature.tsx">
    {icon}
    {description}
  </Stack>;
const PlanBenefitsDescription = withAsyncBoundary(PlanBenefitsDescriptionInner, {
  pendingFallback: <>Loading...</>,
  rejectedFallback: () => null
});